export class NotificationDto {
    constructor(id, userId, notificationMessage, notificationTitle, viewed, notified, 
        webRoutingLink, mobileRoutingLink, category, type, logoutRequired) {
            this.id = id;
            this.userId = userId;
            this.notificationMessage = notificationMessage;
            this.notificationTitle = notificationTitle;
            this.viewed = viewed;
            this.notified = notified;
            this.webRoutingLink = webRoutingLink;
            this.mobileRoutingLink = mobileRoutingLink;
            this.category = category;
            this.type = type;
            this.logoutRequired = logoutRequired;

    }
}
